import { withMetadata } from '../metadata'
import { isSupportedCountry as _isSupportedCountry } from '../../core/index'

export function isSupportedCountry() {
	return withMetadata(_isSupportedCountry, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/isSupportedCountry.js
// module id = 632
// module chunks = 0